/**
 * Linking a Shopify store that was started by a signed-out visitor. /shopify/link saves the claim
 * here and sends them to log in. Every sign-in path (password, register, Google) then returns to it.
 * It lives in sessionStorage, so it belongs to this tab only and is gone when the tab closes.
 */
const KEY = 'omnibiz.pendingShopifyClaim';

export function savePendingShopifyClaim(claim: string): void {
  try {
    sessionStorage.setItem(KEY, claim);
  } catch {
    // Storage blocked: the merchant just reopens the link from Shopify admin.
  }
}

/** The link page's path for a claim saved before sign-in, or null. Reading it clears it. */
export function takePendingShopifyLink(): string | null {
  try {
    const claim = sessionStorage.getItem(KEY);
    if (!claim) return null;
    sessionStorage.removeItem(KEY);
    return `/shopify/link?claim=${encodeURIComponent(claim)}`;
  } catch {
    return null;
  }
}

/** The store named in a claim, for display only. The API checks the signature. */
export function claimShop(claim: string): string | null {
  try {
    const body = claim.split('.')[0];
    const shop = JSON.parse(atob(body.replace(/-/g, '+').replace(/_/g, '/'))).shop;
    return typeof shop === 'string' ? shop : null;
  } catch {
    return null;
  }
}
